export const FETCH_USER_FIELDS_REQUEST = "FETCH_USER_FIELDS_REQUEST";
export const FETCH_USER_FIELDS_SUCCESS = "FETCH_USER_FIELDS_SUCCESS";
export const FETCH_USER_FIELDS_FAILURE = "FETCH_USER_FIELDS_FAILURE";

export const REQUEST_HANDLER = "REQUEST_HANDLER";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";

export const UPDATE_USER_FIELDS = "UPDATE_USER_FIELDS";
export const DELETE_USER_FIELDS = "DELETE_USER_FIELDS";
